
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      vaFirstName: "",
      vaLastName: "",
      vaNumber: "",
      previousVaExists: false,
      updatePreviousVa: false,
      lastVaId: -1,
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeVaModal");
    },
    sendVa() {
      if (this.previousVaExists) {
        this.updateVa();
      } else {
        this.createVa();
      }
    },
    async createVa() {
      const vaCheckResponse = await axios.post("/checkVA", {
        vaNumber: this.vaNumber,
        vaFirstName: this.vaFirstName,
        vaLastName: this.vaLastName,
      });

      if (vaCheckResponse.status !== 200) return this.$emit("openErrorModal");
      this.closeModal();
      this.$store.dispatch("user/setMe");
    },
    async updateVa() {
      const vaResponse = await axios.put("vas/" + this.lastVaId, {
        vaNumber: this.vaNumber,
        vaFirstName: this.vaFirstName,
        vaLastName: this.vaLastName,
      });
      if (vaResponse.status !== 200) return this.$emit("openErrorModal");
      this.closeModal();
      this.$store.dispatch("user/setMe");
    },
    async findPreviousVa() {
      const lastVa = await axios.get("vas/me/last");
      if (lastVa.status >= 300) {
        return;
      }
      this.previousVaExists = true;
      this.vaFirstName = lastVa.data.inscription.athlete.firstName;
      this.vaLastName = lastVa.data.inscription.athlete.lastName;
      this.vaNumber = lastVa.data.va;
      this.lastVaId = lastVa.data.id;
    },
    toogleUpdateVa() {
      this.updatePreviousVa = true;
    },
  },
  mounted() {
    this.findPreviousVa();
  },
});
